import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'

export const Listing = ({packages, userType}) => {
  const { t } = useTranslation('common')

  const text = config.registrationForm.package.listing
  return <tr>
    <td>{t(text)} <strong>{userType}</strong></td>
    {
      packages.map(item => <td key={item.id}>{<i className={`ico-${item.listing ? `ima` : `nema`} ico`} />}</td>)
    }
  </tr>
}

Listing.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    listing: PropTypes.bool
  })).isRequired,
  userType: PropTypes.string.isRequired
}

Listing.defaultProps = {
  packages: []
}
